const sdtConstants = {
    SDT_FILESHARE: process.env.REACT_APP_SDT_FILESHARE
};

export default sdtConstants